import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import FourPillarsForm from './components/FourPillarsForm';
import FourPillarsResult from './components/FourPillarsResult';
import { Box, Button } from '@mui/material';
import './App.css';

// 🎨 カスタムテーマ設定
const theme = createTheme({
  palette: {
    primary: {
      main: '#6D597A',
    },
    secondary: {
      main: '#B56576',
    },
    background: {
      default: '#F7F7F2',
      paper: '#EAECEF',
    },
    text: {
      primary: '#2E2E2E',
      secondary: '#595959',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 500,
      color: '#4A4A4A',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          boxShadow: 'none',
          padding: '8px 24px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        },
      },
    },
  },
});

function App() {
  const [result, setResult] = useState(null);

  const handleReset = () => {
    setResult(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <header className="App-header">
          <h1>AIが語る四柱推命</h1>
          <h2>Four Pillars of Destiny</h2>
        </header>
        <main>
          {!result ? (
            <FourPillarsForm onSubmit={setResult} />
          ) : (
            <>
              <FourPillarsResult result={result} />
              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Button variant="outlined" onClick={handleReset}>
                  入力画面に戻る
                </Button>
              </Box>
            </>
          )}
        </main>
        <footer>
          <p>
            © 2025{' '}
            <a href="https://ai-trans-labo.fun/" target="_blank" rel="noreferrer">
              AI翻訳研究所
            </a>
          </p>
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default App;

